import withStyles from "react-jss"
import { MuteIcon } from "."
import { TRANSITION_DURATION } from "../styles/globalStyles"
import colors from "../styles/colors"

const styles = {
  container: {
    marginRight: "16px",
  },
  row: {
    margin: "0 0 16px 0",
    display: "inline-flex",
    alignItems: "center",
    border: ({ playing }) =>
      `1px solid ${playing ? colors.pink : colors.outlineGrey}`,
    transition: `border ${TRANSITION_DURATION} ease-in`,
    borderRadius: "20px",
    padding: "6px 12px",
  },
  text: {
    fontFamily: "WiredMono",
    fontWeight: 400,
    fontSize: "12px",
  },
}

const PlayButton = ({ classes, playing }) => {
  return (
    <div className={classes.row}>
      <MuteIcon playing={playing} />
      <p className={classes.text}>TAP TO {playing ? "MUTE" : "LISTEN"}</p>
    </div>
  )
}

export default withStyles(styles)(PlayButton)
